export { default, getStaticProps } from 'src/pages/Membership/pages/Product'
